import React from 'react';
import PropTypes from 'prop-types';

const BankReviewLink = ({ siteLink, issuer }) =>
  siteLink ? (
    <div>
      <a href={siteLink}>Learn more about {issuer}</a>
    </div>
  ) : null;

BankReviewLink.propTypes = {
  issuer: PropTypes.string,
  siteLink: PropTypes.string,
};

export default BankReviewLink;
